import { FileText } from 'lucide-react';
import {
	getProntuarioClinicalHistoryVisibleFields,
	type ProntuarioClinicalHistoryRecord,
} from '../types/prontuarioClinicalHistory';
import { ProntuarioProfileFieldList } from './prontuario/ProntuarioProfileFieldList';
import { ProntuarioProfileEmptyState } from './prontuario/ProntuarioProfileEmptyState';
import { ProntuarioReadonlyField } from './SessionCallProntuarioFields';

type SessionCallProntuarioHistoricoTabProps = {
	record?: ProntuarioClinicalHistoryRecord | null;
	variant?: 'default' | 'profile';
	profileTheme?: 'dark' | 'light';
};

const SessionCallProntuarioHistoricoTab = ({
	record = null,
	variant = 'default',
	profileTheme = 'dark',
}: SessionCallProntuarioHistoricoTabProps) => {
	const visibleFields = record
		? getProntuarioClinicalHistoryVisibleFields(record)
		: [];

	if (visibleFields.length === 0) {
		return (
			<ProntuarioProfileEmptyState
				variant={profileTheme}
				title="Nenhum histórico clínico registrado"
				description="O histórico clínico do participante será exibido aqui quando houver registros."
				icon={<FileText className="size-5 shrink-0" strokeWidth={2} />}
			/>
		);
	}

	if (variant === 'profile') {
		return (
			<ProntuarioProfileFieldList
				variant={profileTheme}
				fields={visibleFields.map(({ key, label, fullWidth }) => ({
					label,
					value: record![key]!.trim(),
					multiline: fullWidth,
				}))}
			/>
		);
	}

	return (
		<div className="grid grid-cols-1 gap-3.5">
			{visibleFields.map(({ key, label, fullWidth }) => (
				<ProntuarioReadonlyField
					key={key}
					label={label}
					value={record![key]!.trim()}
					fullWidth={fullWidth}
					appearance="material"
				/>
			))}
		</div>
	);
};

export { SessionCallProntuarioHistoricoTab };
